<template>
    <section class="assessmentSection questionsSection">
        <div class="questionsTopBG"></div>
        <div class="pageContent">
            <div class="pageTitle hasSubtitle">
                <span v-if="!fromAdditionalEquipment">
                    How many exterior doors do you have?
                </span>

                <span v-if="fromAdditionalEquipment">
                    You have <b>{{ lead.homeDoorsQty }}</b> exterior doors protected,
                    <br>
                    How many more do you want to protect?
                </span>
            </div>
            <div class="pageSubtitle">
                We need to secure all exterior doors.
            </div>

            <true-panel class="doorsInputPanel"
                        id="homeDoorsQty">
                <div class="system-design-question-answer">
                    <input type="number"
                           pattern="[0-9]*"
                           ref="focusInput"
                           class="doorInput no-spin"
                           v-if="!fromAdditionalEquipment"
                           v-model="lead.homeDoorsQty">
                    <input type="number"
                           pattern="[0-9]*"
                           ref="focusInput"
                           class="doorInput no-spin"
                           v-if="fromAdditionalEquipment"
                           v-model="lead.homeDoorsQtyMore">
                </div>
            </true-panel>

            <!-- <div class="doorsHelp">
                Any door leading outside is an exterior door.
            </div> -->

            <continue-button ref="continueButton"
                             :before="addAdditionalDoors"
                             :disabled="continueButtonDisabled"
                             :to="to" />
        </div>
    </section>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            fromAdditionalEquipment: false,
            answer: null
        };
    },
    computed: {
        ...mapState(["lead", "previousRoute"]),

        /**
         * [continueButtonDisabled description]
         * @return {[type]} [description]
         */
        continueButtonDisabled() {
            let qty = this.lead.homeDoorsQty;
            return qty == null || qty == "";
        },

        /**
         * [to description]
         * @return {[type]} [description]
         */
        to() {
            let protectionLevel = this.lead.protectionLevel;

            if (this.fromAdditionalEquipment) {
                return "/assessment/system";
            }

            switch (protectionLevel) {
                case "Enhanced":
                    return "/assessment/areas-of-concern";
                    break;
                case "Total":
                    return "/assessment/accessible-areas";
                    break;
                default:
                    return "/assessment/system";
            }
        }
    },
    methods: {
        addAdditionalDoors() {
            let additional = parseInt(this.lead.homeDoorsQtyMore);
            let doors = parseInt(this.lead.homeDoorsQty);
            let totalDoors = doors + additional;
            this.$store.state.lead.homeDoorsQty = totalDoors;
            this.$store.state.lead.homeDoorsQtyMore = 0;
        },
        focus() {
            console.log("click");
            this.$refs.focusText.focus();
        },
        addDoors() {
            let doorLabels = [
                "Front Door",
                "Back Door",
                "Side Door",
                "Patio Door"
            ];
            let count = parseInt(this.answer);
            for (var i = 0; i < count; i++) {
                let door = {
                    label: ""
                };

                if (doorLabels[i]) {
                    door.label = doorLabels[i];
                }

                this.$root.lead.homeDoors.push(door);
            }

            this.$root.nextSection();
        }
    },
    mounted() {
        // this.$refs.focusInput.focus()
        this.$refs.trigger.click();

        // If from additional equipment
        if (this.previousRoute.path.indexOf("additional-equipment") > -1) {
            this.fromAdditionalEquipment = true;
        }
    }
};
</script>

<style lang="css">

</style>
